/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MyInjector } from '@src/app/app.module';
import { Txn } from '@src/app/model/txn';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { PurchasePageComponent } from '@src/app/modules/txn/purchase-page/purchase-page.component';
import { concatMap } from 'rxjs/operators';
import { PurchaseService } from '@src/app/modules/txn/purchase.service';

export class CreditInvoiceAction implements IFormAction {
    name = $localize`Credit Invoice`;
    color: ActionColor = 'warn';
    show = false;
    icon = 'assignment_returned';
    approvalNeeded = true;
    approvalText = $localize`Create a credit note to reverse this purchase invoice?`;
    txn: Txn;

    action(): Observable<Txn> {
        console.log('Took Action');
        const txn = new Txn();
        txn.typeId = Txn.TYPE.PURCHASE_CN.id;
        txn.supplierId = this.txn.supplierId;
        txn.reference = $localize`Credit for ${this.txn.reference}`;
        txn.svcFrom = this.txn.svcFrom;
        txn.svcTo = this.txn.svcTo;
        txn.debit = this.txn.credit;
        txn.notes = $localize`Credit note against our refNr ${this.txn.refNr}`;
        txn.relatedId = this.txn.id;
        txn.lineItems = [];
        txn.relations = [this.txn];
        this.txn.details.forEach(td => {
            if (td.typeId === Txn.TYPE.PURCHASE_ITEM.id || td.typeId === Txn.TYPE.PURCHASE_CN_ITEM.id) {
                const ct = new Txn();
                ct.bCodeId = td.bCodeId;
                ct.scheduleId = td.scheduleId;
                ct.credit = td.debit;
                txn.lineItems.push(td);
            }
        });
        const d = MyInjector.instance.get(MatDialog);
        return d.open(PurchasePageComponent, { data: { txn, hideTabs: true, reverseInvoice: this.txn } })
            .afterClosed().pipe( concatMap(cn => {
            console.log(cn);
            if (cn) {
                const ps = MyInjector.instance.get(PurchaseService);
                return ps.getOne(this.txn.id, null);
            }
        }));
    }

    setup(txn: Txn) {
        this.txn = txn;
        this.show = false;
        if (this.txn.typeId === Txn.TYPE.PURCHASE.id && txn.credit === txn.outstanding) {
            this.show = true;
        }
    }
}
